/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/prefer-promise-reject-errors */

import axios from "axios";
import { createBrowserHistory } from "history";
import { CURRENT_URL } from "../constants";

export const ENDPOINT = import.meta.env.VITE_APP_ENDPOINT;
export const WEB_ENDPOINT = import.meta.env.VITE_APP_WEB_ENDPOINT;
export const WEBSOCKET_ENDPOINT = import.meta.env.VITE_APP_WEBSOCKET_ENDPOINT;
export const MEETING_EVENTS_ENDPOINT =
    import.meta.env.VITE_APP_MEETING_EVENTS_ENDPOINT || "";

export const instance = axios.create({
    baseURL: ENDPOINT,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

export const API = instance;

instance.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token && config.headers) {
            config.headers.authorization = `Token token=${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

instance.interceptors.response.use(
    (response) => response,
    function (error) {
        if (error.message && error.message === "Network Error") {
            const history = createBrowserHistory();
            createBrowserHistory().push(
                `/errors/network?on=${history.location.pathname}`
            );
            window.location.reload();
            return;
        }

        if (error.response.status === 401) {
            localStorage.clear();
            localStorage.setItem(
                CURRENT_URL,
                window.location.pathname + window.location.search
            );
            window.location.href =
                error.response.data && error.response.data.redirect_url
                    ? `/?redirect_url=${error.response.data.redirect_url}`
                    : "/";
            return Promise.reject(error.response);
        }
        return Promise.reject(error.response);
    }
);

function getToken(): string | undefined {
    const token = localStorage.getItem("token");
    if (token !== null) {
        return token;
    }

    return undefined;
}
